// SelectDropdown.jsx
import React, { useRef, useEffect } from 'react'
import TextInput from './TextInput'
import SearchOptionsGroup from 'components/Bimlink/ArticuloBimLink/SearchOptionsGroup'
import { cls } from 'lib/classnames/cn'

const SelectDropdown = ({
  showOptions,
  setShowOptions,
  selectValue,
  label,
  name,
  onChangeValue,
  children,
  containerClassName,
  ...props
}) => {
  const handleMenuOpen = () => {
    if (!showOptions) setShowOptions(true)
  }
  const rootEl = useRef()

  useEffect(() => {
    const handleClickOutside = event => {
      if (rootEl.current && !rootEl.current.contains(event.target)) {
        setShowOptions(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [setShowOptions])

  return (
    <div
      style={{ position: 'relative' }}
      ref={rootEl}
      className={cls(containerClassName)}
    >
      <TextInput
        label={label}
        name={name}
        value={selectValue}
        onFocus={handleMenuOpen}
        onClick={handleMenuOpen}
        onChange={e => onChangeValue(e.target.value)}
        onReset={() => onChangeValue('')}
        autoComplete="off"
        placeholder={props.placeholder}
        {...props}
      />

      {showOptions && (
        <SearchOptionsGroup width={rootEl?.current}>
          {children}
        </SearchOptionsGroup>
      )}
    </div>
  )
}

export default SelectDropdown
